'use client';

import { pushToAdobeDataLayer } from '@analytics/adobe';
import { TrackingEvent } from '@analytics/shared';

export const adobeDispatcher = (trackingEvent: TrackingEvent): void => {
  pushToAdobeDataLayer(trackingEvent);
};
